<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions"><TabHeaderActions /></div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn"
                        :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom
                        :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button v-if="access.elements.actionCrud" variant="link"
                        class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar categoría" aria-label="Agregar categoría" @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>
        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="flex: 1 1 260px; max-width: 340px;">
              <label class="filter-label">Buscar</label>
              <b-form-input type="text" size="sm" placeholder="Nombre o ID" v-model="table.filter" />
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-table class="app-table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :filter="table.filter"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    v-if="table.items.length">

                <template v-slot:cell(id)="data">
                  <b>{{ data.item.id }}</b>
                </template>

                <template v-slot:cell(hours)="data">
                  {{ data.item.hours }} Hs.
                </template>

                <template v-slot:cell(salary)="data">
                  <div v-if="access.elements.showSalary">
                    {{Intl.NumberFormat('es-AR',{style:'currency',currency:'ARS'}).format(data.item.salary)}}                  
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>                

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right no-caret size="sm" variant="link" boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-category-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }"
                              v-if="access.elements.actionCrud">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="category" title="No se encontraron categorías" />
            <div class="app-table-footer">
              <span class="list-view-toolbar__count">{{ getRowCount(table.items) }} registros</span>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <div>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <AppIcon name="arrow_back" class="mr-1" />
              Volver
            </b-button>                        
          </div>

          <nav>
              <b-pagination class="mb-0"
                            size="sm"
                            pills=""
                            :total-rows="getRowCount(table.items)"
                            :per-page="table.perPage"
                            v-model="table.currentPage" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">                  
        <div slot="modal-header" minimize class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="category" /></span>
          <h5 class="app-modal-header__title">{{ modal.form.title }}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>
                    
          <b-col md="6">
            <b-form-group label="Horas Diarias">
              <b-form-input type="number"
                            size="sm"
                            v-model="crud.form.hours"                            
                            placeholder="Ingresar las horas diarias para la catgoría">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Salario Mensual">
              <app-number-input size="sm"
                                v-model="crud.form.salary"
                                placeholder="Ingresar el sueldo genérico de la categoría" />
            </b-form-group>
          </b-col>          

        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      TabHeaderActions,
    },
    data: () => {
      return {      
        access: {
          module_id: Modules.EMPLEADOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudCategory',
          elements: {
            actionCrud: true,
            showSalary: true,            
          }
        }, 
        table : {
          items: [],
          fields: [],
          filter: null,
          currentPage: 1,
          perPage: 50,
        },
        filtersOpen: false,
        isMobileViewport: false,
        mobileMql: null,
        crud: {
          form: {
            id: 0,
            name: '',
            hours: 0,
            salary: 0,
          },          
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
        }        
      }
    },
    created () {     
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      this.access.elements.actionCrud = Helper.hasAccessElement(this.access, 'action_crud')
      this.access.elements.showSalary = Helper.hasAccessElement(this.access, 'show_salary')            
      /* Fin configuracion */
    },  
    watch: {
      filtersOpen(value) {
        StorageLocal.setValue('filters_open_crud_employee_category', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.setFields()
      },
    },
    mounted() {
      this.filtersOpen = StorageLocal.getValue('filters_open_crud_employee_category') == 'true'
      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
      this.setFields()
      this.load()
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    methods: {
      setFields() {
        this.table.fields = [
          {key: 'id', label: 'ID', sortable: true, class: 'align-middle'},
          {key: 'name', label: 'Nombre', class: 'align-middle'},
          {key: 'hours', label: 'Horas diarias', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'salary', label: 'Salario mensual', class: 'align-middle ' + this.alignClass('text-center')},
          {key: 'f_action', label: this.isMobileViewport ? 'Acciones' : '', class: 'align-middle ' + this.alignClass('text-center')},
        ]
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      getRowCount (items) {
        return items.length
      },
      load() {
        var result = serviceAPI.obtenerCategoria()

        result.then((response) => {
          var data = response.data
          this.table.items = data
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error))
        });        
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = '' 
        this.crud.form.hours = 0 
        this.crud.form.salary = 0 

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Categoría"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name   
        this.crud.form.hours = item.hours
        this.crud.form.salary = item.salary     

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Categoría"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name        

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Categoría',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarCategoria(this.crud.form.id);

            result.then(() => {
              this.modal.form.active = false        
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        var result = this.crud.form.id
          ? serviceAPI.editarCategoria(this.crud.form)
          : serviceAPI.agregarCategoria(this.crud.form)

        result.then(() => {
          this.modal.form.active = false
          loader.hide()
          this.load()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }    
  }
</script>
<style scoped>
  .btn.crud-category-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }

  .btn.crud-category-action-toggle-labeled:hover,
  .btn.crud-category-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }

  @media (max-width: 767.98px) {
    .app-table.b-table-stacked-md > tbody > tr > td:last-child {
      text-align: left !important;
    }
  }
</style>
